module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/mobile/2@2.png?77463c0acac9881a74e055b4cc842148";